export default __webpack_public_path__ + "static/media/mastercard.760e49f5.png";